import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    ViewEncapsulation,
} from '@angular/core';

import { OwnDataStatus, StatusLabels } from '../../enums/status-document.enum';
import StatusIcon from '../../enums/status-icon.enum';
import { RowTable } from '../../interfaces/row-table.interface';

@Component({
    selector: 'mapp-file-status-chip',
    templateUrl: './file-status-chip.component.html',
    styleUrls: ['./file-status-chip.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FileStatusChipComponent implements OnChanges {
    @Input() rowTable: RowTable;

    color: string;

    icon: StatusIcon | '';

    text: string;

    textColor: string;

    /**
     *
     */
    ngOnChanges(): void {
        switch (this.rowTable.status) {
            case OwnDataStatus.COMPLETED:
                this.color = '#14853D';
                this.icon = StatusIcon.Done;
                this.text = 'Done';
                this.textColor = '#fff';
                break;

            case OwnDataStatus.PARTIAL_COMPLETED:
                this.color = '#14853D';
                this.icon = StatusIcon.Done;
                this.text = 'Partial Completed';
                this.textColor = '#fff';
                break;

            case OwnDataStatus.FAILED:
                this.color = '#C53532';
                this.icon = StatusIcon.Fail;
                this.text = 'Failed';
                this.textColor = '#fff';
                break;

            case OwnDataStatus.IN_PROGRESS:
                this.color = '#FFBE00';
                this.icon = StatusIcon.InProgress;
                this.text = 'In progress';
                this.textColor = '#000';
                break;

            case OwnDataStatus.INITIATED:
                this.color = '#FFBE00';
                this.icon = StatusIcon.Initiated;
                this.text = StatusLabels.initiated;
                this.textColor = '#000';
                break;

            case OwnDataStatus.DOCUMENT_READY:
                this.color = '#2c6ef2';
                this.icon = StatusIcon.Done;
                this.text = StatusLabels.document_ready;
                this.textColor = '#fff';
                break;

            case OwnDataStatus.DOCUMENT_PARSING:
                this.color = '#FFBE00';
                this.icon = StatusIcon.InProgress;
                this.text = StatusLabels.document_parsing;
                this.textColor = '#fff';
                break;

            case OwnDataStatus.QUESTION_CLASSIFICATION:
                this.color = '#FFBE00';
                this.icon = StatusIcon.InProgress;
                this.text = StatusLabels.question_classification;
                this.textColor = '#fff';
                break;

            case OwnDataStatus.DOCUMENT_TRANSLATION:
                this.color = '#FFBE00';
                this.icon = StatusIcon.InProgress;
                this.text = StatusLabels.document_translation;
                this.textColor = '#fff';
                break;

            case OwnDataStatus.VECTOR_SEARCH:
                this.color = '#FFBE00';
                this.icon = StatusIcon.InProgress;
                this.text = StatusLabels.vector_search;
                this.textColor = '#fff';
                break;

            case OwnDataStatus.LLM_PROCESSING:
                this.color = '#FFBE00';
                this.icon = StatusIcon.InProgress;
                this.text = StatusLabels.llm_processing;
                this.textColor = '#fff';
                break;

            case OwnDataStatus.PARTIAL_FAILURE:
                this.color = '#C53532';
                this.icon = StatusIcon.Fail;
                this.text = StatusLabels.partial_failure;
                this.textColor = '#fff';
                break;

            default:
                this.color = '#FFF';
                this.icon = '';
                this.text = '';
                this.textColor = '#fff';
                break;
        }
    }

    /**
     *
     * @param icon
     */
    getIconPath(icon: string): string {
        return `/assets/icons/${icon}.svg`;
    }
}
